import React from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../Assets/logo.png";
import {AiFillHome, AiFillFileAdd, AiOutlineSearch, AiOutlineInfoCircle, AiOutlineContacts} from 'react-icons/ai'
function Navbar() {
  return (
    <div>
      <div className="flex flex-row items-center z-50 fixed top-0 shadow-lg justify-around bg-white w-screen h-16">
        <Link to="/">
        <img src={logo} className="h-12 p-2" alt="" />
        </Link>
        <div className="hidden md:flex flex-row gap-4 text-lg font-semibold cursor-pointer items-center">
          <NavLink to="/" className={({ isActive }) => (isActive ? "bg-orange-500 text-white p-1 rounded-md": "link")}>
            Home
          </NavLink>
          <NavLink to="/jobpost" className={({ isActive }) => (isActive ? "bg-orange-500 text-white p-1 rounded-md": "link")}>
            Post Job
          </NavLink >
          <NavLink to="/findjob" className={({ isActive }) => (isActive ? "bg-orange-500 text-white p-1 rounded-md": "link")}>
            Find Job
          </NavLink>
          {/* <NavLink to="/about" className={({ isActive }) => (isActive ? "bg-orange-500 text-white p-1 rounded-md": "link")}>
            About Us
          </NavLink> */}
          <NavLink to="/contact" className={({ isActive }) => (isActive ? "bg-orange-500 text-white  p-1 rounded-md": "link")}>
            Contact Us
          </NavLink>
          <a href="http://pcas.poornima.org/about/" className="link border-black border-2 p-1 rounded-md">About Us</a>
        </div>
      </div>
      <div className="flex md:hidden flex-row border-t-4 items-center fixed bottom-0 justify-around bg-white w-screen h-16">
        <div className="flex flex-rosw w-full justify-around text-sm font-semibold cursor-pointer">
          <NavLink to="/" className={({ isActive }) => (isActive ? "flex flex-col items-center text-orange-500": "flex flex-col items-center")}>
            <AiFillHome size={20} />
            Home
          </NavLink>
          <NavLink to="/jobpost" className={({ isActive }) => (isActive ? "flex flex-col items-center text-orange-500": "flex flex-col items-center")}>
            <AiFillFileAdd size={20} />
            Post Job
          </NavLink>
          <NavLink to="/findjob" className={({ isActive }) => (isActive ? "flex flex-col items-center text-orange-500": "flex flex-col items-center")}>
            <AiOutlineSearch size={20} />
            Find Job
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? "flex flex-col items-center text-orange-500": "flex flex-col items-center")}>
            <AiOutlineInfoCircle size={20} />
            About Us
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? "flex flex-col items-center text-orange-500": "flex flex-col items-center")}>
            <AiOutlineContacts size={20} />
            Contact Us
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
